import * as React from 'react'
import { CalendarIcon } from 'lucide-react'
import { format } from 'date-fns'

import { cn } from "@/lib/utils"
import { Button } from '@/components/ui/button'
import { Calendar } from '@/components/ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'

interface DatePickerProps {
    value: Date | null | undefined
    onChange: (date: Date | null | undefined) => void
    placeholder?: string
    error?: boolean
    className?: string
    disabledDays?: any // Accepts Matcher type from react-day-picker
}

export const DatePicker = ({ value, onChange, placeholder = 'Pick a date', error, className, disabledDays }: DatePickerProps) => {
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    className={cn(
                        'h-8 w-full justify-start text-left font-normal',
                        !value && 'text-muted-foreground',
                        error && 'border-red-500',
                        className,
                    )}
                >
                    <CalendarIcon className="mr-2 h-4 w-4" />
                    {value ? format(value, 'PPP') : <span>{placeholder}</span>}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" style={{ 'zIndex': 10000 }} align="start">
                <Calendar mode="single" selected={value || undefined} onSelect={onChange} disabled={disabledDays} initialFocus />
            </PopoverContent>
        </Popover>
    )
}

